import { setupAnalysisRoutes } from './analysis/routes.js'
import { setupIntercompanyRoutes } from './interco/routes.js'
import { setupFinancialsStatementsRoutes } from './statements/routes.js'

/**
 * /app/financials/...
 */
export function setupFinancialsRoutes (baseRoute) {
  // console.log('setupFinancialsRoutes')

  setupFinancialsStatementsRoutes(baseRoute + '/statements')
  setupAnalysisRoutes(baseRoute + '/analysis')
  setupIntercompanyRoutes(baseRoute + '/interco')
}
